import type { ElementTweenFunction } from '../types';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';

export const exitToBottom: ElementTweenFunction = ({ target, options, scrollTrigger, direction }) => {
    if (direction === "back") return { tween: undefined, position: "0" }

    const duration = options?.duration ? options.duration : 1;
    const ease = options?.ease ? options.ease : 'expo.in'; // Changed ease to 'expo.in' for exit

    const tween = gsap.timeline();

    // First animation: Move to y: '450%'
    tween.to(target, { y: '450%', duration, ease });

    // Second animation: Fade out after moving
    tween.to(target, { autoAlpha: 0, duration: 0.2, ease: 'power1.out' }, ">"); // Start immediately after the first animation

    if (scrollTrigger?.trigger) {
        ScrollTrigger.create({
            animation: tween,
            ...scrollTrigger,
        });
    }

    return { tween, position: "<" };
};
